class CartRewardProgress extends HTMLElement {
  cartUpdateUnsubscriber = undefined;
  static isSyncing = false;
  static pending = false;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.syncGiftRewards();
    });
    this.syncGiftRewards();
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber?.();
  }

  async syncGiftRewards() {
    if (!this.querySelector('[data-cart-reward-gift]')) return;
    if (CartRewardProgress.isSyncing) {
      CartRewardProgress.pending = true;
      return;
    }

    CartRewardProgress.isSyncing = true;
    try {
      // Add responses contain only added lines. Always calculate eligibility from the full cart.
      const response = await fetch(routes.cart_url + '.js');
      if (!response.ok) throw new Error(window.cartStrings.error);
      const cart = await response.json();
      if (!this.isConnected) return;
      const qualifyingTotal = cart.items
        .filter((item) => !item.properties?._cart_reward_id)
        .reduce((total, item) => total + item.final_line_price, 0);

      for (const reward of this.querySelectorAll('[data-cart-reward-gift]')) {
        const rewardId = reward.dataset.rewardId;
        const threshold = Number(reward.dataset.threshold);
        const giftLine = cart.items.find((item) => item.properties?._cart_reward_id === rewardId);

        if (qualifyingTotal >= threshold && !giftLine) {
          await this.updateGift(reward.dataset.variantId, rewardId, 1);
          break;
        }

        if (qualifyingTotal < threshold && giftLine) {
          await this.updateGift(giftLine.key, rewardId, 0, true);
          break;
        }
      }
    } catch (error) {
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = error.message;
    } finally {
      CartRewardProgress.isSyncing = false;
      if (CartRewardProgress.pending) {
        CartRewardProgress.pending = false;
        document.querySelector('cart-reward-progress')?.syncGiftRewards();
      }
    }
  }

  async updateGift(id, rewardId, quantity, isLineKey = false) {
    const endpoint = isLineKey ? routes.cart_change_url : routes.cart_add_url;
    const body = isLineKey
      ? { id, quantity, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }
      : { items: [{ id, quantity, properties: { _cart_reward_id: rewardId } }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
    const response = await fetch(endpoint, { ...fetchConfig(), body: JSON.stringify(body) });
    const state = await response.json();
    if (!response.ok || state.errors || state.status) {
      throw new Error(state.description || window.cartStrings.error);
    }
    document.querySelector('cart-drawer')?.renderContents(state);
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-reward-progress', cartData: state });
  }
}

if (!customElements.get('cart-reward-progress')) {
  customElements.define('cart-reward-progress', CartRewardProgress);
}
